/**
 * Description:
 * The keys can be exploited in certain situations to manipulate the behavior of JavaScript objects
 * and even execute attacks like prototype pollution.
 *
 * To ensure the integrity and safety of the data, it is important to sanitize the input object by removing potentially dangerous keys.
 * this function recursively scans and removes such keys from the provided object, such as
 * '__proto__', 'constructor', and 'prototype' from the object and its nested objects.
 *
 * The function is commonly used to process server responses or user-provided data
 * to prevent modification of object prototypes or other security issues.
 *
 * @param {string|Object} data - The response data to be sanitized.
 * @returns {Object} The sanitized object with unsafe keys removed.
 * */
export const transformAndSanitizeResponse = (data) => {
    if (typeof data === 'string') {
        try {
            data = JSON.parse(data);
        }
        catch (err) {
            return data; // Return the original string if parsing fails
        }
    }

    if (typeof data === 'object' && data !== null) {
        const sanitizeObject = (obj) => {
            for (const key in obj) {
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
                    delete obj[key];
                }
                // Recursively sanitize nested objects until we go through whole object!
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    sanitizeObject(obj[key]);
                }
            }
        };

        sanitizeObject(data);
    }

    return data;
};



// WEBPACK FOOTER //
// ./angular-seed-core/src/globalHttpSanitization.js